module.exports = __webpack_public_path__ + "static/media/ios-school.4c5c54db.svg";